import React from 'react'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import MonthlyStatement from './monthly-statement'

export default function LastTwoMonthStatement() {
    return (
        <div>
             <LayoutWithAccountCard breadCumKey='LAST_TWO_MONTH'>
           <MonthlyStatement month="2"/>
            </LayoutWithAccountCard>  
        </div>
    )
}
